window.jQuery(window).on("load", function() {
  // Get the keyword from the URL
  var $_GET = {};
  document.location.search.replace(/\??(?:([^=]+)=([^&]*)&?)/g, function() {
    function decode(s) {
      return decodeURIComponent(s);
    }
    $_GET[decode(arguments[1])] = decode(arguments[2]);
  });

  // Check if the keyword exists and is a string
  var keyword = $_GET["keyword"];
  if (typeof keyword === "string") {
    var keywords = keyword.split(' ');

    for (var index in keywords) {
      keyword = keywords[index];

      console.log(keyword);

      // Search through the practice summary to find the keyword.
      window.jQuery('.cv-intro').each(function() {
        // Define the content to search
        var content = window.jQuery(this).html();

        // Look for the keyword (case-insensitive)
        var regex = new RegExp(keyword, "gi");
        if (content.match(regex)) {
          // Highlight the keyword
          content = content.replace(regex, '<span class="searchTermHighlight">$&</span>');
          window.jQuery(this).html(content);
        }
      });

      // Search through the accordions to find the keyword.
      window.jQuery('.accordion-content').each(function() {
        // Define the content to search 
        var content = window.jQuery(this).html();

        // Look for the keyword (case-insensitive)
        var regex = new RegExp(keyword, "gi");
        if (content.match(regex)) {
          // Highlight the keyword
          content = content.replace(regex, '<span class="searchTermHighlight">$&</span>');
          window.jQuery(this).html(content);

          // Open the accordion
          window.jQuery(this).slideDown();

          // Check for nested accordions
          window.jQuery(this).find('.accordion-content').each(function() {
            // Define the nested accordion content
            var nestedContent = window.jQuery(this).html();

            // Look for the keyword in nested accordion (case-insensitive)
            var regex = new RegExp(keyword, "gi");
            if (nestedContent.match(regex)) {
              // Highlight the keyword
              nestedContent = nestedContent.replace(regex, '<span class="searchTermHighlight">$&</span>');
              window.jQuery(this).html(nestedContent);

              // Open the nested accordion
              window.jQuery(this).slideDown();
            }
          });
        }
      });
    }
  }
});
